module.exports = __webpack_public_path__ + "img/图层 20.438c9a8a.png";